export default __webpack_public_path__ + "static/media/pending.0d3e0c26.png";